import LoadingIndicator from "ds/components/LoadingIndicator";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import DrawerSimple from "ds/components/DrawerNew/Simple";

import useGetUser from "./useGetUser";
import UsersDetailsDrawerContent from "./Content";
import { UserManagementActivationStatus } from "../../types";

type UsersDetailsDrawerProps = {
  userId: string;
  activationStatus: UserManagementActivationStatus;
};

const UsersDetailsDrawer = createDrawer(({ userId, activationStatus }: UsersDetailsDrawerProps) => {
  const { user, loading, error } = useGetUser({
    id: userId,
  });

  if (error) {
    return null;
  }

  return (
    <DrawerSimple>
      {loading && <LoadingIndicator />}
      {user && <UsersDetailsDrawerContent activationStatus={activationStatus} user={user} />}
    </DrawerSimple>
  );
});

export const showUsersDetailsDrawer = createDrawerTrigger(UsersDetailsDrawer);
